/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import "./ExperiencesPro.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FaTrash, FaPen, FaCheck } from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import BtnEcouteMarche from "Components/Boutons/BtnEcouteMarche/BtnEcouteMarche";
import data from "assets/countries";
import { Checkbox } from "primereact/checkbox";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import { fr } from "date-fns/locale";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import BtnBlancLeft from "Components/Boutons/BtnBlancLeft/btn-blanc-left";
import BtnBleuLeft from "Components/Boutons/BtnBleuLeft/btn-bleu-left";
import { updateMenu } from "Redux/Actions/menuActions";
import {
  updateAuth,
  updateExperience,
  updateCompletionLevel,
} from "Redux/Actions/authActions";
import {
  formatDateWihoutDays,
  changeOrderDate,
  addDayToDateAndCompare,
} from "../../../Services/functions";
import axios from "axios";
import { Toast } from "primereact/toast";
import BtnRetour from "Components/Boutons/BtnRetour/btn-retour";
import { useFetchGetConditional } from "Services/api";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";
import { fetchGet, fetchPut } from "Services/apiESA";
import { errorToast, successToast } from "Services/toastFunctions";

const ExperiencesPro = (props) => {
  const [currentUser, setCurrentUser] = useState(props.auth.userConnected);

  // Liste des id à supprimer
  const [deleteIds, setDeleteIds] = useState([]);

  const sectorData = useFetchGetConditional(
    "/sector_of_offers",
    props.auth.token,
    props.secondaryTables.sectorOfOffersData
  );
  const typeOfContractsData = useFetchGetConditional(
    "/type_of_contracts",
    props.auth.token,
    props.secondaryTables.typeOfContractsData
  );
  const domainData = useFetchGetConditional(
    "/domains",
    props.auth.token,
    props.secondaryTables.domainsData
  );

  useEffect(() => {
    sectorData.loaded &&
      typeOfContractsData.loaded &&
      domainData.loaded &&
      props.handleUpdateSecondaryTables({
        sectorOfOffersData: sectorData.data,
        typeOfContractsData: typeOfContractsData.data,
        domainsData: domainData.data,
      });
  }, [sectorData.loaded, typeOfContractsData.loaded, domainData.loaded]);

  const successUpdate = useRef(null);
  const [countForm, setCountForm] = useState(1);

  const [validated, setValidated] = useState(false);
  const [modified, setModified] = useState(false);

  const [errorMessageEndDate, setErrorMessageEndDate] = useState({
    message: "",
    index: null,
  });
  const [experiences, setExperiences] = useState([
    {
      jobname: "",
      company: "",
      typeOfContract: null,
      sector: null,
      domain: null,
      city: "",
      country: null,
      startDate: null,
      endDate: null,
      current: false,
    },
  ]);

  const convertObjectNumericKeys = () => {
    // If experiences is an object, convert it to an array
    if (typeof currentUser.resume.experiences === "object")
      return Object.values(currentUser.resume.experiences);
    return currentUser.resume.experiences;
  };

  useEffect(() => {
    if (currentUser.resume !== null && currentUser.resume?.experiences) {
      setExperiences(convertObjectNumericKeys());
    }
  }, [currentUser]);

  const verifyDataInstance = (i) => {
    if (
      (experiences[i].jobname != "" || experiences[i].jobname != null) &&
      (experiences[i].company != "" || experiences[i].company != null) &&
      (experiences[i].typeOfContract != "" ||
        experiences[i].typeOfContract != null) &&
      (experiences[i].city != "" || experiences[i].city != null) &&
      (experiences[i].country != "" || experiences[i].country != null) &&
      experiences[i].startDate != null &&
      (experiences[i].endDate != null || experiences[i].current)
    ) {
      return true;
    }
    return false;
  };

  const verifyData = () => {
    setValidated(true);
    var verifiedData = true;
    for (let index = 0; index < experiences.length; index++) {
      let check = verifyDataInstance(index);
      verifiedData = verifiedData ? check : false;
    }
    return verifiedData;
  };

  const checkExperiencesBeforeAdd = () => {
    let verifiedData = verifyData();
    addExperience(verifiedData);
  };

  const addExperience = (verifiedData) => {
    setValidated(true);
    if (verifiedData == true) {
      const newExperience = {
        jobname: "",
        company: "",
        typeOfContract: null,
        sector: null,
        domain: null,
        current: false,
        city: "",
        startDate: null,
        endDate: null,
        country: null,
      };
      setCountForm(countForm + 1);
      setExperiences([...experiences, newExperience]);
      setValidated(false);
    }
  };

  const majExperience = (e, i, champ) => {
    const newArray = [...experiences];
    if (champ == "jobname") {
      newArray[i].jobname = e.target.value;
    }
    if (champ == "company") {
      newArray[i].company = e.target.value;
    }
    if (champ == "sector") {
      newArray[i].sector = e.target.value;
    }
    if (champ == "domain") {
      newArray[i].domain = e.target.value;
    }
    if (champ == "typeOfContract") {
      newArray[i].typeOfContract = e.target.value;
    }
    if (champ == "current") {
      newArray[i].current = e.checked;
    }
    if (champ == "city") {
      newArray[i].city = e.target.value;
    }
    if (champ == "startDate") {
      newArray[i].startDate = e;
    }
    if (champ == "endDate") {
      newArray[i].endDate = e;
    }
    if (champ == "country") {
      newArray[i].country = e.target.value;
    }
    setExperiences(newArray);
    verifyData(i);
  };

  const supprExperience = (i, expId) => {
    const newArray = [...experiences];
    // Ajout de l'id à supprimer dans le tableau deleteIds
    if (expId) setDeleteIds([...deleteIds, expId]);
    newArray.splice(i, 1);
    setExperiences(newArray);
  };

  const Valider = async () => {
    setValidated(true);
    let verifiedData = verifyData();
    if (verifiedData) {
      setModified(false);
      await updateExperience();
    }
  };
  const updateExperience = async () => {
    let experiencesArray = [...experiences];

    experiencesArray.forEach((experience) => {
      if (experience.startDate.length < 8)
        experience.startDate = changeOrderDate(experience.startDate);
      if (experience.endDate?.length < 8)
        experience.endDate = changeOrderDate(experience.endDate);

      if (experience.typeOfContract)
        experience.typeOfContract = `/api/type_of_contracts/${experience.typeOfContract.id}`;
      if (experience.domain)
        experience.domain = `/api/domains/${experience.domain.id}`;
      if (experience.sector)
        experience.sector = `/api/sector_of_offers/${experience.sector.id}`;
    });

    // On spécifie les expériences à supprimer
    if (deleteIds.length > 0)
      experiencesArray = [
        ...experiencesArray,
        ...deleteIds.map((id) => ({ id, delete: true })),
      ];

    // On vide le tableau deleteIds
    setDeleteIds([]);

    const cVId = props.auth.userConnected.resume.id;
    const userId = props.auth.userConnected.id;

    const resume = {
      experiences: experiencesArray,
    };

    const updatedUser = await fetchPut(`/cvs/${cVId}`, resume);
    if (updatedUser.error) {
      errorToast(
        updatedUser.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }

    const newExperiences = Object.values(updatedUser.data.experiences);
    props.handleUpdateExperience(newExperiences);
    setExperiences(newExperiences);
    successToast("Votre mise à jour a bien été prise en compte");

    const completionRate = await fetchGet(
      `/users/${userId}/profile_completion_rate`
    );
    if (completionRate.error) {
      errorToast(
        completionRate.error.response?.data?.detail || "Une erreur est survenue"
      );
      return;
    }

    props.handleUpdateCompletionLevel(completionRate.data);
  };

  const findObject = (criteria, value) => {
    if (criteria === "sector" && value) {
      return sectorData.data.find((sector) => sector.label === value.label);
    }
    if (criteria === "typeOfContract" && value) {
      return typeOfContractsData.data.find(
        (typeOfContract) => typeOfContract.label === value.label
      );
    }
    if (criteria === "domain" && value)
      return domainData.data.find((domain) => domain.label === value.label);
  };

  /**
   * Fonction qui permet d'afficher les données d'un champ relationnel (ou string)
   *
   * @param {} data - data à afficher
   * @param {Object[]} reduxData - data redux (objet ou tableau)
   * @returns {String} - data à afficher
   */
  const displayRelationField = (data, reduxData) => {
    if (data?.label) return data.label;
    else if (typeof data === "string") {
      if (data?.includes("/api/")) {
        const uriID = data.split("/")[3];
        return reduxData?.find((item) => item.id == uriID)?.label;
      } else return data;
    } else return "ERREUR";
  };

  //? Fonction qui permet de comparer si la date de début est antérieure à la date de fin et gérer les messages d'erreurs pour l'utilisateur
  const handleDateChangeFin = (endDate, indexExperiences) => {
    let startDate = experiences[indexExperiences].startDate;
    if (startDate !== null) {
      if (addDayToDateAndCompare(startDate, endDate)) {
        setErrorMessageEndDate({
          message: "",
          index: null,
        });
        majExperience(
          new Intl.DateTimeFormat("fr-FR", {
            year: "numeric",
            month: "numeric",
          }).format(endDate, "MM/YYYY"),
          indexExperiences,
          "endDate"
        );
      } else {
        setErrorMessageEndDate({
          message: "La date de début doit être antérieure à la date de fin",
          index: indexExperiences,
        });
      }
    } else {
      setErrorMessageEndDate({
        message: "Veuillez remplir une date de début d'expérience",
        index: indexExperiences,
      });
    }
  };
  return (
    <div>
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="article_actu">
          <NavBarTab
            id="desktop"
            select="profiledit"
            activeIndex={props.activeIndex}
            items={props.items}
          />
          <BtnEcouteMarche items={props.items} />

          <div className="titre_de_page">
            <h1 className="h1_trait_dessus">
              Modifier mes {props.items[props.activeIndex].label}
            </h1>
            <BtnRetour />
          </div>
          <div className="form-demo">
            {/* <div className="flex justify-content-center"> */}
            <div className="card" key={modified}>
              {modified && (
                <div className="counter">
                  <Checkbox
                    id="binary"
                    onChange={() =>
                      props.handleMenu({
                        activeItemProfilEdit: props.items.findIndex(
                          (v) => v.label == "Compétences"
                        ),
                      })
                    }
                    // checked={checked}
                  />
                  <label>
                    Je n&apos;ai pas d&apos;expérience professionnelle
                  </label>
                </div>
              )}
              {domainData.loaded &&
              sectorData.loaded &&
              typeOfContractsData.loaded &&
              modified
                ? experiences?.map((item, indexExperiences) => {
                    return (
                      <div key={"modified uno" + item}>
                        <div className="form_bouton_suppr">
                          <h1>
                            Expérience professionnelle {indexExperiences + 1}
                          </h1>
                          <BtnBlanc
                            btnAction={() => {
                              supprExperience(indexExperiences, item.id);
                            }}
                          >
                            <FaTrash />
                          </BtnBlanc>
                        </div>
                        <div className="form_columns__trois">
                          <div className="field">
                            <h2>Nom de poste *</h2>
                            <InputText
                              id="jobname"
                              placeholder="Chargée de marketing, Assistant de direction..."
                              required
                              value={item.jobname}
                              onChange={(e) =>
                                majExperience(e, indexExperiences, "jobname")
                              }
                            />
                            {item.jobname == "" && validated && (
                              <label className="validation">
                                Le nom de poste doit être renseigné
                              </label>
                            )}
                          </div>
                          <div className="field">
                            <h2>Entreprise *</h2>
                            <InputText
                              id="company"
                              placeholder="Danone, BNP Paribas..."
                              label="Entreprise"
                              value={item.company}
                              onChange={(e) =>
                                majExperience(e, indexExperiences, "company")
                              }
                            />
                            {item.company == "" && validated && (
                              <label className="validation">
                                L&apos;entreprise doit être renseignée
                              </label>
                            )}
                          </div>
                          <div className="field">
                            <h2>Catégorie *</h2>
                            <Dropdown
                              id="typeOfContract"
                              placeholder="Emploi, stage..."
                              value={findObject(
                                "typeOfContract",
                                item.typeOfContract
                              )}
                              options={typeOfContractsData.data}
                              onChange={(e) =>
                                majExperience(
                                  e,
                                  indexExperiences,
                                  "typeOfContract"
                                )
                              }
                            />
                            {item.typeOfContract == null && validated && (
                              <label className="validation">
                                La catégorie doit être renseignée
                              </label>
                            )}
                          </div>
                        </div>
                        <div className="form_columns">
                          <div className="field">
                            <h2>
                              Secteur d&apos;activité de l&apos;entreprise
                            </h2>
                            <Dropdown
                              id="sector"
                              placeholder="Programmation, publicité..."
                              label="Secteur"
                              filter
                              value={findObject("sector", item.sector)}
                              options={sectorData.data.sort((a, b) =>
                                a.label.localeCompare(b.label)
                              )}
                              onChange={(e) =>
                                majExperience(e, indexExperiences, "sector")
                              }
                            />
                          </div>
                          <div className="field">
                            <h2>Domaine du poste occupé</h2>
                            <Dropdown
                              id="domain"
                              placeholder="Audiovisuel, informatique..."
                              label="Domaine"
                              filter
                              value={findObject("domain", item.domain)}
                              options={domainData.data}
                              onChange={(e) =>
                                majExperience(e, indexExperiences, "domain")
                              }
                            />
                          </div>
                        </div>

                        <div className="form_columns">
                          <div className="form_date experience_pro_localisation">
                            <div className="label_date">
                              <h2>Ville *</h2>
                              <InputText
                                id="city"
                                label="Ville"
                                placeholder="Paris, Metz..."
                                value={item.city}
                                onChange={(e) =>
                                  majExperience(e, indexExperiences, "city")
                                }
                              />
                              {item.city == "" && validated && (
                                <label className="validation">
                                  La ville doit être renseignée
                                </label>
                              )}
                            </div>
                            <div className="label_date">
                              <h2>Pays *</h2>
                              <Dropdown
                                id="country"
                                label="Pays"
                                placeholder="France, Belgique..."
                                value={item.country}
                                options={data}
                                editable
                                onChange={(e) =>
                                  majExperience(e, indexExperiences, "country")
                                }
                              />
                              {item.country == null && validated && (
                                <label className="validation">
                                  Le pays doit être renseigné
                                </label>
                              )}
                            </div>
                          </div>
                          <div className="form_date">
                            <div className="label_date">
                              <h2>Date de début *</h2>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={fr}
                              >
                                <DatePicker
                                  label="Date de début"
                                  placeholderText="Click to enter the start date"
                                  selected={
                                    item.startDate === " "
                                      ? null
                                      : item.startDate
                                  }
                                  onChange={(date) => (
                                    setErrorMessageEndDate({
                                      message: "",
                                      index: null,
                                    }),
                                    majExperience(
                                      new Intl.DateTimeFormat("fr-FR", {
                                        year: "numeric",
                                        month: "numeric",
                                      }).format(date, "MM/YYYY"),
                                      indexExperiences,
                                      "startDate"
                                    )
                                  )}
                                  labelFunc={() =>
                                    item.startDate !== "" &&
                                    item.startDate !== null
                                      ? formatDateWihoutDays(item.startDate)
                                      : "09/2019..."
                                  }
                                  views={["year", "month"]}
                                  cancelLabel="Annuler"
                                />
                              </MuiPickersUtilsProvider>
                              {item.startDate == null && validated && (
                                <label className="validation">
                                  La date de début doit être renseignée
                                </label>
                              )}
                            </div>
                            <div
                              className={
                                !item.current
                                  ? "label_date"
                                  : "label_date hidden_date"
                              }
                            >
                              <h2>Date de fin *</h2>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={fr}
                              >
                                <DatePicker
                                  label="Date de fin"
                                  // placeholderText="Click to enter the start date"
                                  selected={
                                    item.endDate === " " ? null : item.endDate
                                  }
                                  onChange={(date) =>
                                    handleDateChangeFin(date, indexExperiences)
                                  }
                                  labelFunc={() =>
                                    item.endDate !== "" && item.endDate !== null
                                      ? formatDateWihoutDays(item.endDate)
                                      : "09/2019..."
                                  }
                                  views={["year", "month"]}
                                  cancelLabel="Annuler"
                                />
                              </MuiPickersUtilsProvider>
                              {item.endDate == null && validated && (
                                <label className="validation">
                                  La date de fin doit être renseignée
                                </label>
                              )}
                              {errorMessageEndDate &&
                                errorMessageEndDate.message !== "" &&
                                errorMessageEndDate.index ==
                                  indexExperiences && (
                                  <p className="errorMessageEndDate">
                                    {errorMessageEndDate.message}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                        <div className="form_columns"></div>
                        <div className="field">
                          <Checkbox
                            label="current"
                            key={item + indexExperiences}
                            // value={item.accept}
                            checked={item.current}
                            onChange={(e) =>
                              majExperience(e, indexExperiences, "current")
                            }
                          />
                          <label htmlFor="current">
                            Il s&apos;agit de mon expérience actuelle
                          </label>
                        </div>
                      </div>
                    );
                  })
                : experiences?.at(0)?.jobname == ""
                ? "Aucune expérience professionnelle de renseignée"
                : experiences
                    ?.sort(
                      (a, b) => new Date(a?.startDate) - new Date(b?.startDate)
                    )
                    ?.sort(
                      (a, b) =>
                        new Date(a?.endDate || Date.now()) -
                        new Date(b?.endDate || Date.now())
                    )
                    ?.sort((a, b) => a?.current - b?.current)
                    .map((item) => {
                      if (item?.jobname)
                        return (
                          <div className="experience" key={item}>
                            <p>
                              {formatDateWihoutDays(item.startDate)} -{" "}
                              {item.current
                                ? "aujourd'hui"
                                : formatDateWihoutDays(item.endDate)}
                            </p>
                            <h4>
                              {item.company} - {item.city} ({item.country})
                            </h4>
                            {item.jobname && (
                              <div className="experience__item">
                                <h5>
                                  <strong>Poste occupé</strong> :{" "}
                                </h5>
                                {item.jobname}
                              </div>
                            )}
                            {item.sector && (
                              <div className="experience__item">
                                <h5>
                                  <strong>Secteur</strong> :{" "}
                                </h5>
                                {displayRelationField(
                                  item.sector,
                                  props.secondaryTables.sectorOfOffersData
                                )}
                              </div>
                            )}
                            {item.domain && (
                              <div className="experience__item">
                                <h5>
                                  <strong>Domaine</strong> :{" "}
                                </h5>
                                {displayRelationField(
                                  item.domain,
                                  props.secondaryTables.domainsData
                                )}
                              </div>
                            )}
                            {item.typeOfContract && (
                              <div className="experience__item">
                                <h5>
                                  <strong>Contrat</strong> :{" "}
                                </h5>
                                {displayRelationField(
                                  item.typeOfContract,
                                  props.secondaryTables.typeOfContractsData
                                )}
                              </div>
                            )}
                          </div>
                        );
                      else return null;
                    })}

              <div className="form_boutons" id="form_boutons">
                {modified ? (
                  <>
                    <div
                      className="form_bouton_add"
                      onClick={() => checkExperiencesBeforeAdd()}
                    >
                      <i className="pi pi-plus-circle" size="2rem" />
                      <label>Ajouter une expérience</label>
                    </div>
                    <div>
                      <BtnBleuLeft
                        btnTexte="Valider "
                        btnAction={async () => await Valider()}
                      >
                        <FaCheck />
                      </BtnBleuLeft>
                    </div>
                  </>
                ) : (
                  <BtnBlancLeft
                    btnTexte="Modifier "
                    btnAction={() => setModified(true)}
                  >
                    <FaPen />
                  </BtnBlancLeft>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ExperiencesPro.propTypes = {
  auth: PropTypes.object,
  secondaryTables: PropTypes.object,
  items: PropTypes.array,
  activeIndex: PropTypes.number,
  handleMenu: PropTypes.func,
  handleUpdateAuth: PropTypes.func,
  handleUpdateExperience: PropTypes.func,
  handleUpdateCompletionLevel: PropTypes.func,
  handleUpdateSecondaryTables: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleUpdateAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleUpdateExperience: (value) => {
    dispatch(updateExperience(value));
  },
  handleUpdateCompletionLevel: (value) => {
    dispatch(updateCompletionLevel(value));
  },
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ExperiencesPro);
